import { ImageCore } from './Core'
import { ImageCardProps } from './interface'
import { ImageCardStoreProvider } from './Store'
import { ImageSynchorizner } from './Synchorizner'

export const ImageCard = (
  /* -------------------------------------------------------------------------- */
  /*                        ImageCardStoreProvider Props                        */
  /* -------------------------------------------------------------------------- */
  props: ImageCardProps
) => {
  return (
    <ImageCardStoreProvider {...props}>
      <ImageCore />
      <ImageSynchorizner />
    </ImageCardStoreProvider>
  )
}
